import styled from 'styled-components';
import {dFlex, dFlexCenter, dFlexColumn, alignCenter, flexWrap, justifyCenter} from '../../../../globalVariables/GlobalFlex';

export const actions = styled.div`
    flex: none;
    background: var(--color-bg-surface-default);
    border-top: 1px solid var(--color-border-subtle);
    overflow: hidden;
`;

export const full = styled.div`
    ${dFlexColumn}
    ${alignCenter}
    gap: var(--space-sm);
    padding: var(--space-sm) var(--space-md);
    max-height: 200px;
    opacity: 1;
    transform: translateY(0);
    transition: max-height 0.32s ease, opacity 0.22s ease, transform 0.32s ease, padding 0.32s ease;

    &.is-collapsed {
        max-height: 0;
        padding-top: 0;
        padding-bottom: 0;
        opacity: 0;
        transform: translateY(100%);
        pointer-events: none;
    }
`;

export const kebab = styled.button`
    ${dFlexCenter};
    width: 100%;
    border: none;
    background: none;
    cursor: pointer;
    color: var(--color-text-default);
    max-height: 0;
    padding: 0;
    opacity: 0;
    overflow: hidden;
    transition: max-height 0.32s ease, opacity 0.22s ease, padding 0.32s ease;

    &.is-collapsed {
        max-height: 40px;
        padding: var(--space-sm);
        opacity: 1;
    }
`;

export const actionsTitle = styled.span`
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-bold);
`;

export const grid = styled.div`
    ${dFlex}
    ${flexWrap}
    ${justifyCenter}
    gap: var(--space-md) var(--space-lg);
    width: 100%;
`;

export const action = styled.button`
    ${dFlexColumn}
    ${alignCenter}
    width: 64px;
    gap: var(--space-xs);
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
    color: var(--color-text-default);

    &.is-danger {
        color: var(--color-state-error-main);
    }
`;

export const iconCircle = styled.span`
    ${dFlexCenter};
    width: 32px;
    height: 32px;
    border-radius: var(--border-radius-border-radius-full);
    background: var(--color-bg-base);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);

    & svg {
        width: 16px;
        height: 16px;
    }

    .is-danger & {
        border: 1.5px solid var(--primitive-red-400);
        background: var(--primitive-white);
    }
`;

export const actionLabel = styled.span`
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-medium);
    text-align: center;
    line-height: 1.2;

    .is-danger & {
        ${dFlexCenter};
        white-space: nowrap;
        padding: var(--space-2xs) var(--space-sm);
        border-radius: var(--border-radius-border-radius-full);
        background: rgba(224, 36, 36, 0.1);

    }
`;
